// Application types

const REVENUE_WALLET_SETTINGS = {
  LOADING_REVENUE_WALLET: "LOADING_REVENUE_WALLET",
  ALL_REVENUE_PAYOUT: "ALL_REVENUE_PAYOUT",
  SEARCHING: "SEARCHING",
  SEARCH_REVENUE_PAYOUT: "SEARCH_REVENUE_PAYOUT",
  GET_MY_REVENUE_PAYOUT: "GET_MY_REVENUE_PAYOUT",
  FILTERING_REVENUE_WALLET: "FILTERING_REVENUE_WALLET",
  FILTER_REVENUE_WALLET: "FILTER_REVENUE_WALLET",
  EDIT_REVENUE_PAYOUT: "EDIT_REVENUE_PAYOUT",
  DOWNLOADING: "DOWNLOADING",
};

export default REVENUE_WALLET_SETTINGS;
